import React from "react";
import { SvgIcon } from "@mui/material";
import SubmitRequestIcon from '../../../../icons/submitRequest.svg?react';
import OnlineApplicationIcon from '../../../../icons/onlineApplication.svg?react';
import ReviewApprovalIcon from '../../../../icons/reviewApproval.svg?react';

export function NextStep(props) {
    const StepList = [
        {
            title: "Complete your entire application online",
            icon: SubmitRequestIcon,
            sublist: [
                {
                    subtitle: `It only takes about ${props.submissionTime} minutes!`
                }
            ]
        },
        {
            title: "Have the following information handy",
            icon: OnlineApplicationIcon,
            sublist: [
                {
                    subtitle: "Driver's License and SSN"
                },
                {
                    subtitle: "Name of Doctor(s)"
                },
                {
                    subtitle: "Name of any medications that <br> you're taking"
                }
            ]
        },
        {
            title: "Electronically sign your application",
            icon: ReviewApprovalIcon,
        }
    ]
    return (
        <div className="step-list">
            {StepList.map((item, key) =>
                <div key={key}>
                    <ul>
                        <li>
                            <div className={`icon-container background-color-16`}>
                                <SvgIcon component={item.icon} color='primary' />
                            </div><span className="lga-title" dangerouslySetInnerHTML={{ __html: item.title }} />
                        </li>
                    </ul>
                    <div className="sub-list">
                        <ul className="step-sub-list mb-0">
                            {item.sublist && item.sublist.map((item, key) => (
                                <li key={key} className="list-item mb-2"><span dangerouslySetInnerHTML={{ __html: item.subtitle }} />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </div>
    )
}